import axios from 'axios';
import {getAccessToken, removeAccessToken} from './account.service';
import { decryptPayload, encryptPayload, isEncryptedEnvelope } from '../utils/payloadCrypto';
import { getCurrentUserLocation } from './location.service';
import { withApiPrefix } from '../utils/apiBaseUrl';

const axiosInstance = axios.create({
  baseURL: withApiPrefix(process.env.REACT_APP_API_URL),
  timeout: 120000,
});

// Request interceptor
axiosInstance.interceptors.request.use(
  async (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    const location = await getCurrentUserLocation();
    if (location) {
      config.headers['x-user-location'] = JSON.stringify(location);
    }

    const contentType = config.headers?.['Content-Type'] || config.headers?.['content-type'];
    const isMultipart = typeof contentType === 'string' && contentType.includes('multipart/form-data');
    const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData;

    if (config.params && Object.keys(config.params).length > 0) {
      config.params = { payload: await encryptPayload(config.params) };
    }

    if (config.data && !isMultipart && !isFormData && !isEncryptedEnvelope(config.data)) {
      config.data = { payload: await encryptPayload(config.data) };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
axiosInstance.interceptors.response.use(
  async (response) => {
    if (response.config.responseType !== 'blob' && isEncryptedEnvelope(response.data)) {
      response.data = await decryptPayload(response.data.payload);
    }

    return response;
  },
  (error) => {
    // Example: Handle 401 errors globally
    if (error.response && error.response.status === 401) {
      removeAccessToken();
        window.location.href = "/login";
    }

    if (error.response && isEncryptedEnvelope(error.response.data)) {
      return decryptPayload(error.response.data.payload)
        .then((data) => {
          error.response.data = data;
          return Promise.reject(error);
        })
        .catch(() => Promise.reject(error));
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
